export default "__VITE_ASSET__7q3sjWaK__"